export default {
  API_REQUEST: 'API_REQUEST',
  API_REQUEST_SUCCESS: 'API_REQUEST_SUCCESS',
  API_REQUEST_ERROR: 'API_REQUEST_ERROR',
  API_REQUEST_CANCEL: 'API_REQUEST_CANCEL',
};
